// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__2vTYl","filesListContainer":"PosDisputesFiles_filesListContainer__1FaGW","filesButton":"PosDisputesFiles_filesButton__2c7K6"};